function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.93405 6.91712H10.8021C10.9341 6.91712 11.041 6.81007 11.041 6.67814V0.942104C11.041 0.81008 10.9341 0.703125 10.8021 0.703125H7.93405C7.80202 0.703125 7.69507 0.810171 7.69507 0.942104V6.67814C7.69507 6.81016 7.80202 6.91712 7.93405 6.91712Z",
  fill: "#FF6F07"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6983 5.00513H30.1611V6.5347C30.1611 7.44295 29.4919 8.3511 28.5837 8.3511H25.7635C24.7903 8.28212 24.0161 7.50791 23.9471 6.5347V5.00513H12.475V6.5347C12.406 7.50791 11.6318 8.28212 10.6586 8.3511H7.83836C6.93011 8.3511 6.26094 7.44285 6.26094 6.5347V5.00513H2.72374C1.50168 5.0312 0.524628 6.02948 0.524902 7.25182V13.1312H35.897V7.25182C35.8974 6.02948 34.9203 5.0312 33.6983 5.00513Z",
  fill: "#FF6F07"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6201 6.91712H28.4881C28.6201 6.91712 28.7271 6.81007 28.7271 6.67814V0.942104C28.7271 0.81008 28.62 0.703125 28.4881 0.703125H25.6201C25.4881 0.703125 25.3811 0.810171 25.3811 0.942104V6.67814C25.3811 6.81016 25.4881 6.91712 25.6201 6.91712Z",
  fill: "#FF6F07"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.626 27.3757L13.9569 31.2475L17.3985 29.4311L17.733 29.3355L18.0676 29.4311L21.5092 31.2475L20.84 27.3757C20.8145 27.151 20.8838 26.9259 21.0313 26.7543L23.8515 24.0775L19.9797 23.504C19.7534 23.4678 19.558 23.3257 19.4539 23.1215L17.7331 19.6321L16.0123 23.1215C15.9082 23.3257 15.7129 23.4678 15.4865 23.504L11.6147 24.0775L14.435 26.7543C14.5823 26.9258 14.6516 27.1509 14.626 27.3757Z",
  fill: "#FF6F07"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0.524902 34.8803C0.550886 36.0759 1.52775 37.0315 2.72374 37.0313H33.6983C34.8942 37.0315 35.871 36.0759 35.8971 34.8803V14.5652H0.524902V34.8803ZM9.41578 23.3605C9.49209 23.0993 9.71881 22.9104 9.98935 22.8825L14.9127 22.1177L17.1116 17.6723C17.3091 17.3291 17.7476 17.2111 18.0907 17.4086C18.2004 17.4717 18.2913 17.5627 18.3544 17.6723L20.5533 22.1177L25.4767 22.8825C25.7472 22.9104 25.974 23.0994 26.0502 23.3605C26.137 23.6162 26.0616 23.8989 25.859 24.0775L22.3218 27.5191L23.1822 32.4425C23.2154 32.7011 23.1055 32.9574 22.8954 33.1116C22.7698 33.2019 22.6198 33.2518 22.4652 33.255C22.3456 33.2664 22.2261 33.2322 22.1306 33.1594L17.733 30.865L13.3354 33.1594C13.0957 33.3054 12.7903 33.2864 12.5706 33.1116C12.3605 32.9573 12.2507 32.701 12.2838 32.4425L13.1442 27.5191L9.607 24.0775C9.40444 23.8989 9.32905 23.6161 9.41578 23.3605Z",
  fill: "#FF6F07"
});

function SvgEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.ce681543.svg";
export { ForwardRef as ReactComponent };